import { createSharedSlice } from '@luna/state';

const GGO_URL_SUCCESS = 'successURL';
const URL_PARAM_SEPARATOR = '&';
const KEY_VALUE_SEPARATOR = '=';

const useSuccessUrl = createSharedSlice({
    initialState: { url: '' },
    reducers: {
        setUrl(state, action: { payload: string }) {
            state.url = action.payload;
            return state;
        },
    },
});

export const getSuccessUrl = () => {
    const { url } = useSuccessUrl.getState();

    if (url) {
        return url;
    }

    return (
        window.location.search
            .split(URL_PARAM_SEPARATOR)
            .map((param) => {
                const [key, value] = param.split(KEY_VALUE_SEPARATOR);

                return key === GGO_URL_SUCCESS ? value : null;
            })
            .find((value) => !!value) ?? ''
    );
};

export const storeSuccessUrlFromParam = () => {
    useSuccessUrl.dispatchActions.setUrl(getSuccessUrl());
};
